import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { getAll } from '../api/ventura/locationList';
import { useConfig } from './useConfig';

function useAdGroupLocationLists(
  adGroupId: number,
  defaultPerPage: number = 10
) {
  const { apiHost } = useConfig();
  const [page, setPage] = React.useState<number>(0);
  const [perPage, setPerPage] = React.useState<number>(defaultPerPage);
  const query = useQuery({
    queryKey: ['adGroupLocationLists', adGroupId, page, perPage],
    queryFn: () => getAll(apiHost, adGroupId, { page, perPage }),
    enabled: !!adGroupId,
  });

  return { page, setPage, perPage, setPerPage, ...query };
}

export default useAdGroupLocationLists;
